import React from 'react';
import Navbar from '../Components/Navbar';
import Heroimg2 from '../Components/Heroimg2';
import Footer from '../Components/Footer';
import Exp from '../Components/Exp';


const Experience = () => {
  return (
    <div>
      <Navbar/>
      <Heroimg2 heading="EXPERIENCE" 
      text="Electronics & Communication graduate with 3+ years of experience."/>
      
      <Exp/>
      <Footer/>
      
    </div>
  )
}

export default Experience
